
import { icons } from './icons.ts';

export class AppIcon extends HTMLElement {
    static get observedAttributes() {
        return ['name', 'size'];
    }

    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.render();
    }

    attributeChangedCallback(name: string, oldValue: string, newValue: string) {
        if (oldValue !== newValue) {
            this.render();
        }
    }

    render() {
        if (!this.shadowRoot) return;

        const name = this.getAttribute('name') || '';
        const size = this.getAttribute('size') || 'md';
        const iconContent = icons[name] || '';

        let sizePx = '20'; // md
        if (size === 'sm') sizePx = '16';
        if (size === 'lg') sizePx = '24';
        if (size === 'xl') sizePx = '32';
        if (size === 'xs') sizePx = '12';

        // Derive a stable seed from the icon name for consistent wobble per icon type
        const seed = name.split('').reduce((acc: number, c: string) => acc + c.charCodeAt(0), 0);

        this.shadowRoot.innerHTML = `
            <style>
                :host {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    vertical-align: middle;
                }
                svg.icon {
                    width: ${sizePx}px;
                    height: ${sizePx}px;
                    stroke: currentColor;
                    fill: none;
                    stroke-width: 2;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    filter: url(#icon-sketch-${seed});
                }
            </style>
            <svg style="position:absolute;width:0;height:0;overflow:hidden;" aria-hidden="true">
              <defs>
                <filter id="icon-sketch-${seed}" x="-5%" y="-5%" width="110%" height="110%">
                  <feTurbulence type="turbulence" baseFrequency="0.03" numOctaves="3" seed="${seed}" result="noise" />
                  <feDisplacementMap in="SourceGraphic" in2="noise" scale="1.5" xChannelSelector="R" yChannelSelector="G" />
                </filter>
              </defs>
            </svg>
            ${iconContent ? `<svg class="icon" viewBox="0 0 24 24">${iconContent}</svg>` : ''}
        `;
    }
}

customElements.define('app-icon', AppIcon);
